import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [ticks, setTicks] = useState(0);

  useEffect(() => {
    if (!sessionId || ticks > 30) return;
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setStatus(data);
        if (data.payment_status === "paid") return;
      } catch { /* ignore, will retry */ }
      setTicks((n) => n + 1);
    }, 2000);
    return () => clearTimeout(t);
  }, [sessionId, ticks]);

  const paid = status.payment_status === "paid";

  return (
    <div className="max-w-[720px] mx-auto px-6 lg:px-12 py-24" data-testid="payment-success-page">
      <div className="surface-card p-10 text-center">
        {paid ? (
          <>
            <CheckCircle2 size={72} className="mx-auto text-green-400 mb-4" />
            <h1 className="font-display text-4xl mb-3">MEMBERSHIP ACTIVE</h1>
            <p className="text-[var(--ff-text-dim)] font-mono-ui text-sm mb-6">
              Thanks for supporting the show. Your perks are unlocked in your Memberships dashboard.
            </p>
            <div className="flex justify-center gap-3">
              <Link to="/memberships" className="btn-primary" data-testid="payment-success-memberships">Go to Memberships</Link>
              <Link to="/shows" className="btn-ghost" data-testid="payment-success-shows">Browse More Shows</Link>
            </div>
          </>
        ) : (
          <>
            <Loader2 size={64} className="mx-auto text-[var(--ff-red)] mb-4 animate-spin" />
            <h1 className="font-display text-3xl mb-3">CONFIRMING PAYMENT…</h1>
            <p className="text-[var(--ff-text-dim)] font-mono-ui text-sm">
              Waiting for Stripe to confirm. This usually takes just a moment.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
